import { Select as SingleSelect } from '@lokalise/louis'
import type { AiConfigProject } from '@lokalise/translation-api-schemas'
import type { Tag } from '@lokalise/workspaces-api-schemas'
import { requiredErrorMessage } from '../../../../../constants/errors'
import type { CreationConfigAllowedTypes } from '../../../../../types/tag'
import { Select as MultiSelect } from '../../../../Select/Select'

import styles from './DataSource.module.css'

type DataSourceProps = {
  dataSource: CreationConfigAllowedTypes | null
  hasClickedNext: boolean
  isLoadingTags?: boolean
  isLoadingProjects?: boolean
  projects: AiConfigProject[]
  tags: Tag[]
  selectedTag: string | null
  selectedProjects: string[]
  onProjectsChange: (projects: string[]) => void
  onTagChange: (tag: string | null) => void
}

export const DataSource = ({
  dataSource,
  hasClickedNext,
  selectedProjects,
  selectedTag,
  onProjectsChange,
  onTagChange,
  tags,
  isLoadingProjects,
  isLoadingTags,
  projects,
}: DataSourceProps) => {
  const isTagsDropdown = dataSource === 'tags'
  const specifySourceError =
    hasClickedNext && !selectedTag && !selectedProjects.length && requiredErrorMessage

  if (dataSource === null) {
    return null
  }

  return (
    <>
      {isTagsDropdown ? (
        <div className="flex-col gap-2">
          <span className={styles.heading} id="tag-label">
            Specify data source
          </span>
          <SingleSelect
            aria-labelledby="tag-label"
            placeholder="Select tag"
            options={tags}
            onChange={(option) => onTagChange(option?.value ?? null)}
            getOptionLabel={(option) => option.value}
            getOptionValue={(option) => option.value}
            isLoading={isLoadingTags}
            value={tags.find((tag) => tag.value === selectedTag)}
            error={specifySourceError}
          />
        </div>
      ) : (
        <MultiSelect
          title="Specify data source"
          name="projects"
          placeholder={'Select projects'}
          options={projects}
          selectedOptions={projects.filter((project) => selectedProjects.includes(project.id))}
          onSelectionChange={(selection) =>
            onProjectsChange(selection?.map((project) => project.id))
          }
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          isLoading={isLoadingProjects}
          maxVisibleOptions={5}
          error={specifySourceError}
        />
      )}
    </>
  )
}
